import { ioExtend } from '@framework';

export class SettingsModel {

    direction= "ltr";
    bgColor= "black";
    transparentColor= "";
    bgImage= "assets/img/sidebar-bg/01.jpg";
    bgImageDisplay= true;
    compactMenu= false;
    sidebarSize= "sidebar-lg";
    layout= "Light";

    //CSP Add-ons
    Language = 'en';
    DataTableClass = 'material';
    MobilePrinterMAC = '';

    //LogoImage = "assets/img/logos/default.logo-color-big.png"

    constructor(_settings?: {}) {
        ioExtend(this, _settings);
    };

}

